<div class="why" id="why">
  <div class="container">
    <div class="row justify-content-center justify-content-xxl-between">
      <div
        class="why__content-text d-flex flex-column col-12 col-xxl-5"
        data-aos="fade-right"
        data-aos-easing="linear"
        data-aos-duration="700"
      >
        <h2 class="m-0">Why Nice Project?</h2>
        <p class="display display-3r m-0">
          Join our team and experience a challenging and rewarding work
          environment, where you'll have the opportunity to work on cutting-edge
          projects and continuously develop your skills.
        </p>
        <p class="_1r m-0">
          We prioritize work-life balance and offer enticing perks and flexible
          work arrangements to support our employees' well-being. We empower
          individuals to reach their fullest potential and thrive in our
          collaborative and innovative organizational culture.
        </p>
      </div>
      <div
        class="why__content-carousel col-12 offset-xxl-1 col-xxl-6"
        data-aos="fade-left"
        data-aos-easing="linear"
        data-aos-duration="700"
      >
        <app-carousel-testimonials
          [testimonialsArray]="testimonialsConfigCarousel"
        ></app-carousel-testimonials>
      </div>
    </div>
  </div>
</div>
